import { ProcedureStepDefaultAssigneeService as OvermapProcedureStepDefaultAssigneeService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepDefaultAssigneeService extends OvermapProcedureStepDefaultAssigneeService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
